import React, { useState, useEffect, useMemo } from 'react'
import { Formik, Field, Form } from 'formik'
import ReactTable from 'react-table'
import Select from 'react-select'
import dayjs from 'dayjs'
import { useDispatch, useSelector } from 'react-redux'
import { defaultFulfillmentCenterTypeFilters } from 'src/features/fulfillmentCenterFilters'
import { selectFulfillmentCenters } from 'src/features/selector'
import { actions } from 'src/features/state'
import { getStockMovimentations } from 'src/services/stock/stockService'
import Text from 'src/components/Text'
import Button from 'src/components/Button'
import Loading from 'src/components/Loading'
import * as S from './Movimentation.styles'
import 'react-table/react-table.css'

const DefaultFulfillmentCenter = { label: 'TODOS', value: '' }

const newTableColumn = ({ id, ...config }) => {
  return {
    Header: <Text text={`movimentation.table.header.${id}`} />,
    id: id,
    accessor: id,
    ...config
  }
}

const isDateRangeGreaterThan30Days = (dateFrom, dateTo) => {
  return Math.abs(dayjs(dateTo).diff(dateFrom, 'day')) > 30
}

const Movimentation = () => {
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(false)
  const [movimentations, setMovimentations] = useState([])
  const [errorMessage, setErrorMessage] = useState()
  const [selectedFC, setSelectedFC] = useState(DefaultFulfillmentCenter)
  const fulfillmentCenters = useSelector(selectFulfillmentCenters)
  const FCs = useMemo(() => [
    DefaultFulfillmentCenter,
    ...fulfillmentCenters.map(({ id, name }) => ({
      label: name,
      value: id
    }))
  ], [fulfillmentCenters])

  const handleSubmit = async ({ dateFrom, dateTo }) => {
    setMovimentations([])
    setErrorMessage()

    if (isDateRangeGreaterThan30Days(dateFrom, dateTo)) {
      setErrorMessage('Selecione datas com no máximo 30 dias de diferença')
      return
    }

    setLoading(true)

    const response = await getStockMovimentations({
      dateFrom,
      dateTo,
      fulfillmentCenterId: selectedFC?.value
    })

    setLoading(false)

    if (response.isOk) {
      setMovimentations(response.data)

      return
    }

    setErrorMessage(
      'Ocorreu um erro ao listar as movimentações, tente novamente'
    )
  }

  const handleChangeFC = (selectedOption) => {
    setSelectedFC(selectedOption)
  }

  useEffect(() => {
    dispatch(actions.getAvailableFulfillmentCenters(defaultFulfillmentCenterTypeFilters))
  }, [dispatch])

  useEffect(() => {
    const selectedFulfillmentCenterExists = FCs.some(({ value }) => value === selectedFC?.value)

    if (!selectedFulfillmentCenterExists) {
      setSelectedFC(DefaultFulfillmentCenter)
    }
  }, [FCs, selectedFC])

  return (
    <>
      <S.Container>
        <Text textType="header" text="movimentation" />

        <Formik
          initialValues={{
            dateFrom: '',
            dateTo: ''
          }}
          onSubmit={handleSubmit}
        >
          <S.Form as={Form}>
            <S.FormGroup>
              <label htmlFor="dateFrom">Data Inicial:</label>
              <S.DateInput
                as={Field}
                required
                type="date"
                id="dateFrom"
                name="dateFrom"
              />
            </S.FormGroup>

            <S.FormGroup>
              <label htmlFor="dateTo">Data Final:</label>
              <S.DateInput
                as={Field}
                required
                type="date"
                id="dateTo"
                name="dateTo"
              />
            </S.FormGroup>
            <S.FormGroup>
              <label htmlFor="fc">FC:</label>
              <S.Select
                as={Select}
                id="fc"
                name="fc"
                options={FCs}
                value={selectedFC}
                onChange={handleChangeFC}
              />
            </S.FormGroup>
            <S.FormGroup>
              <S.SearchButton
                as={Button}
                text="movimentation.form.filter"
                type="submit"
              />
            </S.FormGroup>
          </S.Form>
        </Formik>
        {errorMessage && <S.ErrorSummary> {errorMessage} </S.ErrorSummary>}

        <S.TableContainer>
          <S.Table
            as={ReactTable}
            data={movimentations}
            getTdProps={() => {
              return {
                style: {
                  overflow: 'hidden'
                }
              }
            }}
            defaultPageSize={movimentations.length}
            pageSize={movimentations.length}
            minRows={0}
            columns={[
              newTableColumn({ id: 'fulfillmentCenter.name', width: 100 }),
              newTableColumn({ id: 'collaborator', width: 80 }),
              newTableColumn({ id: 'type', width: 80 }),
              newTableColumn({ id: 'productCode', width: 80 }),
              newTableColumn({ id: 'description', width: 300 }),
              newTableColumn({
                id: 'quantity',
                width: 60,
                style: { textAlign: 'right' }
              }),
              newTableColumn({
                id: 'balance',
                width: 90,
                style: { textAlign: 'right' }
              }),
              newTableColumn({ id: 'address', width: 100 }),
              newTableColumn({ id: 'justification', width: 250 }),
              newTableColumn({ id: 'movimentationDate', width: 100 }),
              newTableColumn({ id: 'expirationDate', width: 100 })
            ]}
            showPagination={false}
          />
        </S.TableContainer>
      </S.Container>

      <S.Loading as={Loading} loading={loading} />
    </>
  )
}

export default Movimentation
